import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import { useAuth } from 'hooks/useAuth';
import { useAccount } from 'hooks/useAccount';

export const ModuleRoute = ({ children, requiredModule, requiredRole, isUserOnlyModule }) => {
  const { user } = useAuth();
  const { account, isLoading } = useAccount();

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <MoonLoader color="#556ee6" size={90} speedMultiplier={0.5} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  const userModules = user?.modules;

  if (requiredModule) {
    const accountModules = account?.modules || {};

    const accountHasModule = accountModules[requiredModule];
    const userHasModule = userModules?.[requiredModule];
    const hasRequiredModule = isUserOnlyModule ? userHasModule : userHasModule && accountHasModule;

    const hasRequiredRole = requiredRole
      ? Array.isArray(requiredRole)
        ? requiredRole.includes(user.adminStatus)
        : user.adminStatus === requiredRole
      : true;

    const userHasAccess = hasRequiredModule && hasRequiredRole;

    if (!userHasAccess) {
      return <Navigate to="/" />;
    }
  }

  return children;
};

ModuleRoute.propTypes = {
  children: PropTypes.node,
  requiredModule: PropTypes.string,
  requiredRole: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  isUserOnlyModule: PropTypes.bool,
};
